import { formatDecimal, monedaSimbolo } from "../../utils/formatters";

// Medalla por posición (oro / plata / bronce / resto)
const rankClass = (i) =>
  i === 0
    ? "bg-gradient-to-br from-amber-400 to-amber-600 text-white"
    : i === 1
    ? "bg-gradient-to-br from-slate-300 to-slate-500 text-white"
    : i === 2
    ? "bg-gradient-to-br from-amber-700 to-amber-900 text-white"
    : "bg-sirius-50 text-sirius-700";

export default function CardTopProducts({
  products = [],
  limit = 5,
  onChangeLimit,
  currency,
  title = "Top Productos/Servicios",
}) {
  const monedaLabel = monedaSimbolo(currency);
  return (
    <div className="sirius-card flex flex-col w-full h-[420px] overflow-hidden">

      {/* HEADER */}
      <div className="px-5 py-4 border-b border-slate-100 flex justify-between items-center">
        <div className="flex items-center gap-3 min-w-0">
          <span className="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center text-white bg-gradient-to-br from-sirius-600 to-spark-500 shadow-spark">
            <i className="fas fa-box-open" />
          </span>
          <div className="min-w-0">
            <h6 className="uppercase text-ink-400 text-[0.66rem] font-display font-semibold tracking-[0.14em]">
              Ranking
            </h6>
            <h2 className="text-ink-900 text-lg font-display font-bold leading-tight truncate">
              {title}
            </h2>
          </div>
        </div>

        <select
          value={limit}
          onChange={(e) => onChangeLimit(Number(e.target.value))}
          className="shrink-0 border border-slate-200 rounded-lg px-2.5 py-1.5 text-xs font-medium text-ink-700 focus:outline-none focus:ring-2 focus:ring-sirius-400/30"
        >
          <option value={5}>Top 5</option>
          <option value={10}>Top 10</option>
          <option value={20}>Top 20</option>
          <option value={50}>Top 50</option>
        </select>
      </div>

      {/* COLUMN HEADER */}
      <div className="bg-sirius-50/60 px-5 py-2.5 text-[0.7rem] font-display font-semibold uppercase tracking-wider text-sirius-700 flex justify-between">
        <span>Producto</span>
        <span>Ventas ({monedaLabel})</span>
      </div>

      {/* LIST */}
      <div className="overflow-y-auto flex-1 text-sm sidebar-scroll">
        {products.length > 0 ? (
          products.map((p, i) => (
            <div
              key={i}
              className="px-5 py-2 flex justify-between items-center gap-3 border-b border-slate-50 hover:bg-sirius-50/50 transition-colors"
            >
              {/* PRODUCT INFO */}
              <div className="flex items-center gap-3 min-w-0">
                <span className={`shrink-0 w-7 h-7 rounded-lg flex items-center justify-center text-xs font-display font-bold ${rankClass(i)}`}>
                  {i + 1}
                </span>
                <div className="flex flex-col min-w-0 leading-tight">
                  <span className="font-semibold text-ink-900 truncate">
                    {p.producto_nombre}
                  </span>
                  <span className="text-[11px] text-ink-400">
                    {p.producto_sku}
                  </span>
                </div>
              </div>

              {/* SALES INFO */}
              <div className="flex flex-col items-end whitespace-nowrap">
                <span className="font-display font-bold text-sirius-700">
                  {formatDecimal(p.total_ventas)}
                </span>
                <span className="text-[11px] text-ink-400">
                  {p.total_unidades} unidades
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-center px-4">
            <i className="fas fa-box-open text-4xl text-sirius-200 mb-3" />
            <p className="text-ink-400 text-sm">No hay productos registrados</p>
          </div>
        )}
      </div>
    </div>
  );
}
